<template>
  <div
    id="reset-password"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <form
                class="p-8 login-tabs-container"
                @submit.prevent="resetPassword"
              >
                <div class="vx-card__title">
                  <h4 class="pb-4">
                    Passwort zurücksetzen
                  </h4>
                </div>

                <div>
                  <DataInput
                    v-model="form.email"
                    required
                    type="email"
                    class="w-full mt-4"
                    label="E-Mail"
                    name=""
                  />
                  <DataInput
                    v-model="form.password"
                    required
                    type="password"
                    class="w-full mt-4"
                    label="Neues Passwort"
                    name="password"
                  />
                  <DataInput
                    v-model="form.passwordConfirmation"
                    required
                    type="password"
                    class="w-full mt-4"
                    label="Neues Passwort bestätigen"
                    name="passwordConfirmation"
                  />
                  <DataInput
                    v-model="dataprotection"
                    required
                    type="bool"
                    class="w-1/2 mt-4 py-3"
                    label="Datenschutzerklärung akzeptiert"
                    name="dataprotection"
                  />
                  <vs-button class="mt-4" @click="resetPassword"
                    >Passwort zurücksetzen</vs-button
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { onLogin } from "@/vue-apollo";
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  data: () => ({
    form: {
      email: "",
      password: "",
      passwordConfirmation: ""
    },
    dataprotection: false
  }),
  methods: {
    resetPassword() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($input: ResetPasswordInput!) {
              resetPassword(input: $input)
            }
          `,
          variables: {
            input: {
              email: this.form.email,
              password: this.form.password,
              token: this.$route.params.token
            }
          }
        })
        .then(async ({ data }) => {
          await onLogin(this.$apollo, data.resetPassword);
          await this.$store.dispatch("user/fetchUser", this.$apollo);
          this.$router.push("/");
        })
        .catch(error => {
          this.loginErrors = error.graphQLErrors.map(m => m.message);
        });
    }
  }
};
</script>
